import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { ExpansionRun, ExpansionRunReport } from './types';

const validate = (runId: number, subscriptionId: number) => {
  if (!runId || runId < 1) {
    throw new Error('Valid run ID is required');
  }
  if (!subscriptionId || subscriptionId < 1) {
    throw new Error('Valid subscription ID is required');
  }
};

type RequestParams = {
  runId: number;
  /**
   * Any subscription of the organization — the API authorises the caller against it and scopes
   * every read by organization, never by this id.
   */
  subscriptionId: number;
};

export type GetRunResponse = {
  run: ExpansionRun;
  // `summary.live: true` for a run that has not completed yet — see `ExpansionLiveRunSummary`.
  summary: ExpansionRunReport | null;
};

export const getRun = async (
  scope: RequestScope,
  { runId, subscriptionId }: RequestParams,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<GetRunResponse>> => {
  try {
    validate(runId, subscriptionId);

    const result = await scopedChannelApi(scope).get<GetRunResponse>(`atts/expansion/runs/${runId}`, {
      ...options,
      headers: {
        'x-astur-subscription-id': subscriptionId.toString(),
      },
    });

    return {
      data: result.data,
      status: result.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
